import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { labelActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const Labels = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
	const  labels  = useSelector((state) => state.labels);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "type_name",
      headerName: "Label Type Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "name",
      headerName: "Label Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "image",
      headerName: "Image",
      minWidth: 100,
      flex: 1,
      hide: true,
    },
    {
      field: "image_url",
      headerName: "image_url",
      minWidth: 100,
      flex: 1,
      hide: true,
    },
    {
      field: "label_type_id",
      headerName: "Label Type",
      width: 150,
      hide: true,
},
  ];

  const recordIdentifier = "labelname";

  useEffect(() => {
    dispatch(labelActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
	<DataTable
        loading={labels?.loading}
        rows={labels?.items?.data}
        columns={columns}
        recordIdentifier={recordIdentifier}
        actionIdentifier="labelActions"
        recordType={"label"}
        search ={searchQuery}
		hasSeparateView={{ active: true, param: "id", suffix: "/view" }}
      />    </Box>
  );
};

export default Labels;